import React, { useCallback, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import BottomBar from "../BottomBar";
import "./explore.css";
import { useDispatch, useSelector } from "react-redux";
import { chefActions } from "../../store/chefSlice";

import {
  FREE_DILIVERY_DISTANCE_RANGE,
  MINIMUM_AMOUNT_MAX_RANGE,
  MINIMUM_AMOUNT_MIN_RANGE,
  ORDER_DISTANCE_RANGE,
  ORDER_DISTANCE_RANGE_MIN,
  S3_MENU_THUMBNAIL_FOLDER,
} from "../../store/constants";
import { EffectFade } from "swiper/modules";
// import SwiperCore from "swiper/core";

import "swiper/css";
import { useEffect, useState } from "react";
import {
  updateExploreDishes,
  updatePausedDishesInfo,
} from "../../store/loginActions";
import ReactInstaStories from "../../components/InstaStoriesPackage/index.tsx";
import ExploreStory from "./exploreStory";
import InstallModal from "../InstallModal/Index";
import VegChoiceModal from "../VegChoiceModal/Index";
import {
  getLabelsArray,
  getLabelsArrayValue,
  isWebApp,
} from "../../utils/helper";
import {
  getChefExperiencesExploreList,
  getSortedExploreDishes,
} from "./exploreDataHelper";
import mixpanel from "mixpanel-browser";
import { loginActions } from "../../store/loginSlice";
import { toast } from "react-toastify";
import { uniqBy } from "lodash";
import { cartAction } from "../../store/cartSlice";
import LocationChoiceModal from "../VegChoiceModal/LocationChoiceModal";
import { bottomBarActions } from "../../store/bottomBarSlice";
import { storieAction } from "../../store/storieSlice";
import RecommendationModal from "./RecommendationModal";
import JoinWaitlistComponent from "./JoinWaitlistComponent";
import GuideOverlay from "./GuideOverlay/GuideOverlay.js";
import GuideOverlayTap from "./GuideOverlay/GuideOverlayTap.js";
// import clevertap from 'clevertap-web-sdk';

// SwiperCore.use([EffectFade]);

const BOTTOM_BAR_SPACE = 60; // TODOWAITLIST: to show bottom bar value = 60

const Explore = (props) => {
  const { isModalOpen, setIsModalOpen } = props;
  const [showInstallModal, setShowInstallModal] = useState(false);
  const [showInstallModalAnswered, setShowInstallModalAnswered] =
    useState(false);
  const showInstallModalAnsweredRef = useRef();
  const isAutoStoryEndRef = useRef();
  const distanceMatrixRef = useRef(null);
  const swiperIndexRef = useRef();
  const [showChoiceModal, setShowChoiceModal] = useState(false);
  const foodChoiceSelection =
    useSelector(({ auth }) => auth.user.foodChoice) || [];

  const [showWaitListScreen, setShowWaitListScreen] = useState(false);
  const [showExploreScreen, setShowExploreScreen] = useState(true);
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [adjustedHeight, setAdjustedHeight] = useState(
    window.innerHeight - BOTTOM_BAR_SPACE
  );
  const webviewLocationObjValue =
    JSON.parse(localStorage.getItem("webviewLocationObj")) || {};
  const [webviewLocationObj, setWebviewLocationObj] = useState(
    webviewLocationObjValue
  );
  const foodChoice = localStorage.getItem("foodChoice");
  const chefList = useSelector((state) => state.chef.chefList);
  const [foodChoiceState, setFoodChoiceState] = useState(foodChoice || "");
  const [run, setRun] = useState(true);
  const [location, setLocation] = useState({
    loaded: false,
    coordinates: { lat: "", lng: "" },
  });
  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const viewportHeight = window.innerHeight;
  const screenHeight = viewportHeight - BOTTOM_BAR_SPACE;
  const categories = useSelector((state) => state.chef.categories);
  const user = useSelector(({ auth }) => auth.user);
  const coordsSelector = useSelector(({ auth }) => auth.coords);
  const categoriesLoaded = useSelector((state) => state.chef.categoriesLoaded);
  const addresses = user.addressLine1;
  const startTimestampRef = useRef(null);
  const playerRefs = useRef([]);

  const isWebview = window.location.search.includes("?webview=true");
  const isAppInstalled =
    isWebview || /wv/i.test(navigator.userAgent) || !isWebApp();
  const isIosAppInstalled =
    isWebview ||
    (navigator.userAgent.includes("Mobile/") &&
      !navigator.userAgent.includes("Safari/")) ||
    !isWebApp();
  const dispatch = useDispatch();

  const catName = useSelector((state) => state.chef.categoryName);
  const dishRecommendation = useSelector(({ auth }) => auth.dishRecommendation);
  const chefExperiences = useSelector(
    (state) => state.chef.chefExperiences
  );
  // const chefListLoaded = useSelector((state) => state.chef.chefListLoaded);

  // const chefId = props.dishes.map((item) => item?.chefId);
  const [swiper, setSwiper] = useState(null);
  // const [isAllVideoMuted, setIsAllVideoMuted] = useState(false);
  // const isAllVideoMutedRef = useRef(false);
  const [slideResetKeys, setSlideResetKeys] = useState({});
  const [activeIndex, setActiveIndex] = useState(0);
  let storiesList = [];
  let storySlideNumber = 0;

  const [my_swiper, set_my_swiper] = useState({});

  const [fetchedVideoDurations, setFetchedVideoDurations] = useState({});



  const sortedDailyFirstExploredDishes = getSortedExploreDishes(
    categories,
    foodChoiceState,
    dishRecommendation
  );

  const chefExperiencesExploreList = getChefExperiencesExploreList(
    chefExperiences
  );

  const exploreData = [
    ...sortedDailyFirstExploredDishes,
    ...chefExperiencesExploreList,
  ].slice(0, 15);

  useEffect(() => {
    const fetchMissingDurations = async () => {
      const durationsToFetch = [];

      exploreData.forEach((dish) => {
        dish.stories.forEach((story) => {
          const isVideo = story?.img.includes(".mp4"); // adjust if your value differs
          const videoUrl = story?.videoUrl || story?.video || story?.img; // adjust to the actual field holding the video URL
          const alreadyKnown = !!story?.videoLength;
          const alreadyFetched = fetchedVideoDurations[videoUrl] !== undefined;

          if (isVideo && !alreadyKnown && !alreadyFetched && videoUrl) {
            durationsToFetch.push(videoUrl);
          }
        });
      });

      if (durationsToFetch.length === 0) return;

      const uniqueUrls = [...new Set(durationsToFetch)];
      const results = await Promise.all(
        uniqueUrls.map(async (url) => {
          try {
            const seconds = await getVideoDuration(url);
            return [url, seconds * 1000]; // convert to ms
          } catch (err) {
            console.error(err);
            return [url, null];
          }
        })
      );

      setFetchedVideoDurations((prev) => {
        const updated = { ...prev };
        results.forEach(([url, ms]) => {
          if (ms !== null) updated[url] = ms;
        });
        return updated;
      });
    };

    fetchMissingDurations();
  }, [exploreData]);

  const merged = [].concat.apply([], Object.values(categories));
  const categoriesWithClass = merged.filter((category) => {
    if (category.img)
      return {
        ...category,
        ringClass: "ring-" + category.color,
      };
  });
  let storyNum = categoriesWithClass?.findIndex(
    (category) => category.name === catName
  );

  const getVideoDuration = (url) => {
    return new Promise((resolve, reject) => {
      const video = document.createElement("video");
      video.preload = "metadata";
      video.onloadedmetadata = () => {
        resolve(video.duration); // seconds
        video.remove();
      };
      video.onerror = () => {
        reject(new Error("Failed to load video metadata: " + url));
        video.remove();
      };
      video.src = url;
    });
  }

  useEffect(() => {
    if (swiper) {
      swiper.slideTo(storyNum);
    }
  }, [swiper]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // const muteAllPlayers = useCallback(() => {
  //   playerRefs.current.forEach((ref) => {
  //     const player = ref?.current;
  //     if (player) {
  //       player.mute();
  //     }
  //   });

  //   isAllVideoMutedRef.current = true;
  //   console.log("Muted All: ", isAllVideoMutedRef.current);
  // }, []);

  // const unmuteAllPlayers = useCallback(() => {
  //   playerRefs.current.forEach((ref) => {
  //     const player = ref?.current;
  //     if (player) {
  //       player.unMute();
  //     }
  //   });

  //   isAllVideoMutedRef.current = false;
  // }, []);

  // const checkMuteVideo = () => {
  //   if (isAllVideoMutedRef.current) {
  //     muteAllPlayers();
  //   } else {
  //     unmuteAllPlayers();
  //   }
  // };

  const handleShowModal = () => {
    showInstallModalAnsweredRef.current = true;
    setShowInstallModalAnswered(true);
    if (!!foodChoiceState && isAutoStoryEndRef.current) {
      const canSwipe = swipeToNextSlide();
      if (canSwipe) {
        storySlideNumber = 0;
        my_swiper.slideNext();
      } else {
        dispatch(chefActions.onStoryBackClick());
      }
    }
  };

  const handleFoodChoiceState = (value) => {
    const canSwipe = swipeToNextSlide();
    if (canSwipe) {
      storySlideNumber = 0;
      my_swiper.slideNext();
    } else {
      dispatch(chefActions.onStoryBackClick());
    }
    setFoodChoiceState(value);
  };

  const exploreDishesApi = (dish) => {
    const dishId = dish._id;
    const exploredDishesIdsLocal =
      JSON.parse(localStorage.getItem("@user") || "{}")["exploredDishesIds"] ||
      [];
    const userexploredDishesIds = user.exploredDishesIds || [];
    const allDishesIds = [
      ...exploredDishesIdsLocal,
      ...userexploredDishesIds,
      dishId,
    ];
    const allDishesIdsUniqueArray = [...new Set(allDishesIds)];
    const payload = { exploredDishesIds: allDishesIdsUniqueArray };
    // dispatch(updateExploreDishes(user.userid, payload));
  };


  useEffect(() => {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (
          mutation.type === "childList" &&
          mutation.target.classList.contains("store_location_click_data")
        ) {
          const newTextContent = mutation.target.textContent;
          try {
            const newData = JSON.parse(newTextContent);
            if (newData.type === "ADD_LOCATION") {
              const { type, ...locationObj } = newData;
              setWebviewLocationObj(locationObj);
              onSuccess({
                coords: {
                  longitude: locationObj?.lng,
                  latitude: locationObj?.lat,
                },
              });
              localStorage.setItem(
                "webviewLocationObj",
                JSON.stringify(locationObj)
              );
            }
            // setNotificationData(newData);
          } catch (error) {
            console.error("Error parsing JSON:", error);
          }
        }
      }
    });

    observer.observe(document.body, { subtree: true, childList: true });

    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    playerRefs.current = Array(exploreData.length)
      .fill()
      .map((_, i) => playerRefs.current[i] || React.createRef());
  }, [exploreData]);

  const getNearbyLocations = (currentLat, currentLng, locations) => {
    const threshold = 0.1; // Define your threshold distance in kilometers
    const nearbyLocations = [];

    function getDistance(lat1, lon1, lat2, lon2) {
      const R = 6371; // Radius of the Earth in kilometers
      const dLat = deg2rad(lat2 - lat1);
      const dLon = deg2rad(lon2 - lon1);
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(deg2rad(lat1)) *
        Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const distance = R * c; // Distance in kilometers
      return distance;
    }

    function deg2rad(deg) {
      return deg * (Math.PI / 180);
    }

    locations.forEach((location) => {
      const distance = getDistance(
        currentLat,
        currentLng,
        location.location.lat,
        location.location.lng
      );
      if (distance <= threshold) {
        nearbyLocations.push(location);
      }
    });

    return nearbyLocations;
  };

  const onSelectAddressHandler = (data, autoDetect) => {
    const uniqKitchenData = uniqBy(chefList, (obj) => obj.kitchenId);
    uniqKitchenData
      .filter((a) => a.kitchenId)
      .map((kitchen) => {
        const kitchenId = kitchen.kitchenId;
        const chefLocation = kitchen.chefLocation;
        distanceMatrixRef.current =
          new window.google.maps.DistanceMatrixService();
        const chefLocationObj = {
          lat: +chefLocation?.lat,
          lng: +chefLocation?.lng,
        };
        distanceMatrixRef.current.getDistanceMatrix(
          {
            origins: [chefLocationObj],
            destinations: [
              {
                lat: data?.location.lat,
                lng: data?.location.lng,
              },
            ],
            travelMode: "DRIVING",
          },
          (res, status) => {
            if (status !== "OK") {
              console.log("Unable to fetch...");
            } else {
              let delivery_distance = res.rows[0].elements[0].distance.value;
              let delivery_duration = res.rows[0].elements[0].duration;
              let delivery_destination = res.destinationAddresses[0];
              let deliveryObject = {
                delivery_distance,
                delivery_duration,
                kitchenLocation: chefLocation,
              };

              dispatch(
                loginActions.setDeliveryDetails({
                  kitchenId,
                  payload: deliveryObject,
                })
              );
              let deliverydeliveryDistanceInKMS = Math.round(
                delivery_distance / 1000
              );
              // const requestBody = {
              //   pickup_details: {
              //     building_name: "",
              //     latitude: chefLocation.lat,
              //     longitude: chefLocation.lng,
              //     address: res.originAddresses[0]
              //   },
              //   drop_details: {
              //     building_name: "",
              //     latitude: data?.location.lat,
              //     longitude: data?.location.lng,
              //     address: res.destinationAddresses[0]
              //   }
              // };

              const requestBody = {
                pickup_details: {
                  building_name: "NP Home Foods",
                  latitude: 12.933562657282067,
                  longitude: 77.61429533708163,
                  address:
                    "Apex Building 93/A Ground Floor, A Wing, 4th B Cross, 5th Block, Koramangala, Bengaluru, Karnataka 560095",
                },
                drop_details: {
                  building_name: "NP Sweet Home",
                  latitude: 12.93373883438634,
                  longitude: 77.61620254160374,
                  address:
                    "JNC, Hosur Rd, KHB Colony, 5th Block, Koramangala, Bengaluru, Karnataka 560095",
                },
              };

              // checkDeliveryServiceable(requestBody)
              if (deliverydeliveryDistanceInKMS > ORDER_DISTANCE_RANGE) {
                dispatch(loginActions.setIsServiceable(false));
                dispatch(loginActions.setIsServiceableAlert(true));
                dispatch(loginActions.setUnserviceableModalOnCart(true));
                dispatch(loginActions.setMinimumAmount(0));
              } else if (
                deliverydeliveryDistanceInKMS > ORDER_DISTANCE_RANGE_MIN &&
                deliverydeliveryDistanceInKMS <= ORDER_DISTANCE_RANGE
              ) {
                dispatch(loginActions.setIsServiceable(true));
                dispatch(loginActions.setIsServiceableAlert(false));
                dispatch(loginActions.setFarAwayModalOnCart(true));
                dispatch(
                  loginActions.setMinimumAmount(MINIMUM_AMOUNT_MAX_RANGE)
                );
              } else if (
                deliverydeliveryDistanceInKMS > FREE_DILIVERY_DISTANCE_RANGE &&
                deliverydeliveryDistanceInKMS < ORDER_DISTANCE_RANGE_MIN
              ) {
                dispatch(loginActions.setIsServiceable(true));
                dispatch(loginActions.setIsServiceableAlert(false));
                dispatch(
                  loginActions.setMinimumAmount(MINIMUM_AMOUNT_MIN_RANGE)
                );
              } else {
                dispatch(loginActions.setIsServiceable(true));
                dispatch(loginActions.setIsServiceableAlert(false));
                dispatch(loginActions.setMinimumAmount(0));
              }

              let coords = { lat: data.location.lat, lng: data.location.lng };
              dispatch(loginActions.setSelectedAddress(data));
              dispatch(loginActions.setLocation(data.location.locationName));
              dispatch(cartAction.setIsAddressOptionsVisible(false));
              dispatch(loginActions.setCoords(coords));
              dispatch(loginActions.setLocation(delivery_destination));
            }
          }
        );
      });
  };

  const onSuccess = (location) => {
    const nearbyLocations = getNearbyLocations(
      location.coords.latitude,
      location.coords.longitude,
      addresses
    );
    if (nearbyLocations?.length) {
      onSelectAddressHandler(nearbyLocations[0], false);
    } else {
      setLocation({
        loaded: true,
        coordinates: {
          lat: location.coords.latitude,
          lng: location.coords.longitude,
        },
      });
      onSelectAddressHandler(
        {
          location: {
            lat: location.coords.latitude,
            lng: location.coords.longitude,
          },
        },
        false
      );
      dispatch(
        loginActions.setCoords({
          lat: location.coords.latitude,
          lng: location.coords.longitude,
        })
      );
    }
    setLoading(false);
  };

  const showError = (error) => {
    toast.error(error, {
      position: toast.POSITION.BOTTOM_CENTER,
      toastId: "info1",
    });
  };

  const onError = (error) => {
    if (Object.keys(webviewLocationObj).length !== 0) {
      try {
        // Parse the parameter into a JSON object
        onSuccess({
          coords: {
            longitude: webviewLocationObj?.lng,
            latitude: webviewLocationObj?.lat,
          },
        });
        console.log(webviewLocationObj);
      } catch (error) {
        setLocationError(error);
        console.error("Error parsing JSON:", error);
      } finally {
        setLoading(false);
      }
    } else {
      setLocationError(error);
      setLoading(false);
    }
    setLoading(false);
  };

  const setLocationError = (error) => {
    setLocation({
      loaded: false,
      error: {
        code: error.code,
        message: error.message,
      },
    });
  };

  const swipeToNextSlide = () => {
    if (swiper) {
      const curInd = swiper.activeIndex;
      if (curInd === exploreData?.length - 1) {
        return false;
      } else {
        return true;
      }
    }
  };

  const onGeoLocationClickHandler = (manualClick) => {
    mixpanel.track("geolocation-clicked");
    // clevertap.event.push("geolocation-clicked");
    setLoading(true);
    if (
      manualClick &&
      Object.keys(webviewLocationObj).length === 0 &&
      window.ReactNativeWebView
    ) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ type: "ASK_LOCATION_PERMISSION" })
      );
      setLoading(false);
    } else if (
      Object.keys(webviewLocationObj).length !== 0 &&
      window.ReactNativeWebView
    ) {
      try {
        onSuccess({
          coords: {
            longitude: webviewLocationObj?.lng,
            latitude: webviewLocationObj?.lat,
          },
        });
      } catch (error) {
        setLocationError(error);
        console.error("Error parsing JSON:", error);
      } finally {
        setLoading(false);
      }
    } else if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(onSuccess, onError, {
        enableHighAccuracy: true,
      });
    } else {
      setLoading(false);
      showError("Geolocation not supported");
    }
  };

  const manualLocationClick = () => {
    setShowLocationModal(false);
    dispatch(bottomBarActions.loadTab({ tabName: "chef" }));
    dispatch(bottomBarActions.loadTab({ tabName: "locationSelector" }));
    mixpanel.track("location-clicked");
  };

  useEffect(() => {
    const handleResize = () => {
      setAdjustedHeight(window.innerHeight - BOTTOM_BAR_SPACE);
    };

    // Listen for window resize events
    window.addEventListener("resize", handleResize);

    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleSwipeUp = () => {
    console.log("Swipe Up Detected! Perform an action here.");
    setShowWaitListScreen(true);
    // setTimeout(() => {
    //   setShowExploreScreen(false)
    // }, 100000);
  };

  const isValidLocation =
    !!location?.coordinates?.lat &&
    !!location?.coordinates?.lng &&
    location.loaded;
  const isValidLocationSelector =
    !!coordsSelector?.lat && !!coordsSelector?.lng;
  const isLocationValid = isValidLocation || isValidLocationSelector;

  const isDishesLoading =
    (!sortedDailyFirstExploredDishes || !sortedDailyFirstExploredDishes.length) &&
    (!chefExperiencesExploreList || !chefExperiencesExploreList.length) &&
    !categoriesLoaded;
  // if (isDishesLoading || !categoriesLoaded)
  //   return (
  //     <div className="splash-screen">
  //       <img src="cuirato-splash.png" alt="loading..." />
  //     </div>
  //   );

  const exploreVideos = [];

  // [
  //    { url: "901/Copy_of_biryani_master.mp4", videoLength: 17000 },
  //    { url: "902/Copy_of_butter_chicken_master_2.mp4", videoLength: 15000 },
  //    { url: "903/Copy_of_pasta_master.mp4", videoLength: 18000 },
  //    { url: "904/Copy_of_narogi_master.mp4", videoLength: 18000 },
  //    { url: "905/Copy_of_seekh_kebab_master.mp4", videoLength: 16000 },
  //    { url: "906/Copy_of_chicken_tandoori_master.mp4", videoLength: 18000 },
  //    { url: "907/Copy_of_chicken_bacon_wrapped_master.mp4", videoLength: 20000 },
  //  ];

  //  TODOWAITLIST

  return (
    <div style={{ width: "100%" }}>
      {!isModalOpen ? (
        <div>
          {/* <GuideOverlay /> */}
          {/* <GuideOverlayTap /> */}
          {isDishesLoading ? (
            <div className="splash-screen">
              <img src="cuirato-splash.png" alt="loading..." />
            </div>
          ) : (
            <Swiper
              direction={"vertical"}
              modules={[EffectFade]}
              pagination={{
                clickable: true,
              }}
              height={screenHeight}
              onInit={(ev) => {
                dispatch(storieAction.setSwiperIndex(ev.activeIndex));
                swiperIndexRef.current = ev.activeIndex;
                set_my_swiper(ev);
                setActiveIndex(ev.activeIndex)
              }}
              onSlideChange={(s) => {
                setSlideResetKeys((prev) => ({
                  ...prev,
                  [s.activeIndex]: (prev[s.activeIndex] || 0) + 1,
                }));
                setActiveIndex(s.activeIndex)
                // checkMuteVideo();
                if (
                  s.activeIndex ===
                  exploreData.length - 1
                ) {
                  dispatch(bottomBarActions.loadTab({ tabName: "chef" }));
                }
                dispatch(storieAction.setSwiperIndex(s.activeIndex));
                swiperIndexRef.current = s.activeIndex;
                dispatch(storieAction.setRunJoyride(false));
                setSwiper(s);
                mixpanel.track(`explore dish change`);
                // clevertap.event.push(`explore dish change`);
                if (s.activeIndex > 0) {
                  const prevDish =
                    exploreData[s.activeIndex - 1];
                  exploreDishesApi(prevDish);
                }
                if (s.activeIndex === 1) {
                  if (!isLocationValid) {
                    // setShowLocationModal(true);
                  }
                  console.log("slide change");
                }
                if (
                  !showInstallModalAnsweredRef.current &&
                  s.activeIndex === 2
                ) {
                  if (!isAppInstalled && !isIosAppInstalled) {
                    // setShowInstallModal(true)
                  } else if (!foodChoiceState) {
                    // setShowChoiceModal(true)
                  }
                  console.log("slide change");
                }
              }}
              style={{ height: `${adjustedHeight}px`, background: "#000" }}
              onSwiper={(s) => setSwiper(s)}
              className="explore-swiper-wrapper"
            >
              {exploreData.map((dish, index) => {
                const labelsArrayValue = getLabelsArrayValue(
                  dish,
                  exploreVideos[index]
                );
                const descriptions = dish.stories.map(
                  (item) => item?.description
                );
                const headers = dish?.name;
                const price = dish?.price;
                const chefId = dish?.chefId;
                const description = dish?.description;
                const chefImgs = dish?.chefImg;
                const chefNames = dish?.chefName;
                const labels = dish.stories.map((d) => ({
                  key: d.header,
                  desc: d.caption,
                  img: d.img,
                  videoLength: d?.videoLength,
                  demoLabel: d?.demoLabel,
                  demoDesc: d?.demoDesc,
                  storyType: d?.storyType,
                  storyHeader: d?.storyHeader,
                  dishNameHeader: d?.dishNameHeader,
                }));
                const labelsArray = getLabelsArray(
                  dish,
                  exploreVideos[index],
                  labels
                );
                const storiesArrayData = labelsArray.map((label, i) => {
                  const isVideo = label?.img.includes(".mp4"); // adjust if your value differs
                  const videoUrl = label?.videoUrl || label?.video || label?.img; // adjust to the actual field holding the video URL

                  let totalTime;

                  if (isVideo) {
                    if (label?.videoLength) {
                      // Duration already known from backend
                      totalTime = label.videoLength;
                    } else if (fetchedVideoDurations[videoUrl]) {
                      // Duration fetched client-side via metadata
                      totalTime = fetchedVideoDurations[videoUrl];
                    } else {
                      // Metadata not fetched yet (first render) — keep the default progress duration
                      totalTime = 5000; // matches defaultInterval; original code used label?.videoLength + 1000 || 5000
                    }
                  } else {
                    const dishDescription = label?.desc || label?.demoDesc || "";
                    const words = dishDescription.split(" ");
                    totalTime = ((words.length - 1) * 0.15 + 0.3 + 3) * 1000;
                  }

                  return {
                    content: ({ action, isPaused }) => {
                      if (showInstallModal || showChoiceModal) {
                        action("pause");
                      }
                      return (
                        <ExploreStory
                          key={dish._id}
                          dishKey={i}
                          img={label.img || dish.stories[0].img}
                          action={action}
                          labels={labels}
                          labelDesc={label}
                          dishInfo={dish}
                          isPaused={isPaused}
                          swiper={swiper}
                          headers={headers}
                          exploreIndex={index}
                          name={dish?.categoryHeader}
                          categoryImg={
                            dish.categoryImg
                              ? S3_MENU_THUMBNAIL_FOLDER + dish.categoryImg
                              : ""
                          }
                          price={price}
                          dishSpecialType={dish?.dishSpecialType}
                          chefId={chefId}
                          description={descriptions[i] || description}
                          storyImages={dish.storyImages}
                          chefImg={chefImgs}
                          chefName={chefNames}
                          categoryId={dish.categoryId}
                          ref={playerRefs.current[index]}
                          // muteAllPlayers={muteAllPlayers}
                          // unmuteAllPlayers={unmuteAllPlayers}
                          run={run}
                          setRun={setRun}
                        />
                      );
                    },
                    preloadResource: true,
                    duration: totalTime,
                  };
                });
                return (
                  <SwiperSlide key={index}>
                    {index === activeIndex ? (
                      <ReactInstaStories
                        key={`${index}-${slideResetKeys[index] || 0}`}
                        isPaused={true}
                        loop
                        stories={storiesArrayData}
                        defaultInterval={5000}
                        width="100%"
                        preloadCount={2}
                        height={screenHeight}
                        progressContainerStyles={{ top: "2px" }}
                        instaIndex={index}
                        onStoryStart={(s) => {
                          if (index === swiperIndexRef.current) {
                            startTimestampRef.current = performance.now();
                            storySlideNumber = s;
                          }
                        }}
                        onStoryEnd={(s) => {
                          // ignore story-end events from slides that aren't visible
                          if (index !== swiperIndexRef.current) return;

                          mixpanel.track(`explore story end`);
                          isAutoStoryEndRef.current = true;
                          exploreDishesApi(dish);
                          storySlideNumber = s;
                          if (startTimestampRef.current !== null) {
                            const endTimestamp = performance.now();
                            const timeDifference =
                              endTimestamp - startTimestampRef.current;
                            if (timeDifference > 5300) {
                              const pausedDishesIds = user.pausedDishesIds || [];
                              const allDishesPausedIds = [
                                ...new Set([...pausedDishesIds, dish._id]),
                              ];
                              const payload = {
                                pausedDishesIds: allDishesPausedIds,
                              };
                              // dispatch(updatePausedDishesInfo(user.userid, payload));
                            }
                            startTimestampRef.current = performance.now();
                          }
                          // if (s === dish.stories.length + 1 - 1) {
                          if (s === labelsArrayValue.length - 1) {
                            if (
                              showInstallModalAnswered ||
                              isAppInstalled ||
                              isIosAppInstalled
                            ) {
                              const canSwipe = swipeToNextSlide();
                              if (canSwipe) {
                                storySlideNumber = 0;
                                my_swiper.slideNext();
                              } else {
                                dispatch(chefActions.onStoryBackClick());
                              }
                            } else {
                              if (!isAppInstalled && !isIosAppInstalled) {
                                // setShowInstallModal(true)
                              } else if (!foodChoiceState) {
                                // setShowChoiceModal(true)
                              } else {
                                const canSwipe = swipeToNextSlide();
                                if (canSwipe) {
                                  storySlideNumber = 0;
                                  my_swiper.slideNext();
                                } else {
                                  dispatch(chefActions.onStoryBackClick());
                                }
                              }
                            }
                          }
                        }}
                      />
                    ) : (
                      <div style={{ height: screenHeight, background: "#000" }}>
                        {/* optional poster: <img src={dish.stories[0]?.img} style={{ width: "100%", height: "100%", objectFit: "cover" }} /> */}
                      </div>
                    )}
                  </SwiperSlide>
                );
              })}
            </Swiper>
          )}
        </div>
      ) : (
        <RecommendationModal
          isModalOpen={isModalOpen}
          handleCancel={handleCancel}
          setFoodChoiceState={handleFoodChoiceState}
          foodChoiceState={foodChoiceState}
        />
      )}
      {showWaitListScreen && (
        <JoinWaitlistComponent setShowWaitListScreen={setShowWaitListScreen} />
      )}
      {showWaitListScreen && (
        <JoinWaitlistComponent setShowWaitListScreen={setShowWaitListScreen} />
      )}
      <InstallModal
        isOpen={showInstallModal}
        setOpen={setShowInstallModal}
        setShowChoiceModal={setShowChoiceModal}
        foodChoiceState={foodChoiceState}
        setShowInstallModalAnswered={handleShowModal}
      />
      <VegChoiceModal
        isOpen={showChoiceModal}
        setOpen={setShowChoiceModal}
        setFoodChoiceState={handleFoodChoiceState}
      />
      <LocationChoiceModal
        isOpen={showLocationModal}
        setOpen={setShowLocationModal}
        loading={loading}
        isLocationValid={isLocationValid}
        manualLocationClick={manualLocationClick}
        onGeoLocationClickHandler={onGeoLocationClickHandler}
      />
      {/* TODO: show bottom bar */}
      {!isModalOpen && !isDishesLoading && <BottomBar isExplore />}
    </div>
  );

  // return (
  //   <div className="exploreScreenWrapper">
  //     {showExploreScreen && (
  //       <>
  //         {!isModalOpen ? (
  //           <Swiper
  //             direction={"vertical"}
  //             modules={[EffectFade]}
  //             pagination={{
  //               clickable: true,
  //             }}
  //             height={screenHeight}
  //             onInit={(ev) => {
  //               dispatch(storieAction.setSwiperIndex(ev.activeIndex));
  //               swiperIndexRef.current = ev.activeIndex;
  //               set_my_swiper(ev);
  //             }}
  //             onSlideChange={(s) => {
  //               // if (s.activeIndex === sortedDailyFirstExploredDishes.length - 1) {
  //               //   dispatch(bottomBarActions.loadTab({ tabName: "chef" }));
  //               // }
  //               // TODO: need to enable to redirect to chef screen when last explore story
  //               dispatch(storieAction.setSwiperIndex(s.activeIndex));
  //               swiperIndexRef.current = s.activeIndex;
  //               dispatch(storieAction.setRunJoyride(false));
  //               setSwiper(s);
  //               mixpanel.track(`explore dish change`);
  //               // clevertap.event.push(`explore dish change`);
  //               if (s.activeIndex > 0) {
  //                 const prevDish =
  //                   sortedDailyFirstExploredDishes[s.activeIndex - 1];
  //                 exploreDishesApi(prevDish);
  //               }
  //               if (s.activeIndex === 1) {
  //                 if (!isLocationValid) {
  //                   // setShowLocationModal(true);
  //                 }
  //                 console.log("slide change");
  //               }
  //               if (
  //                 !showInstallModalAnsweredRef.current &&
  //                 s.activeIndex === 2
  //               ) {
  //                 if (!isAppInstalled && !isIosAppInstalled) {
  //                   // setShowInstallModal(true);
  //                 } else if (!foodChoiceState) {
  //                   // setShowChoiceModal(true);
  //                 }
  //                 console.log("slide change");
  //               }
  //             }}
  //             style={{ height: `${adjustedHeight}px`, background: "#000" }}
  //             onSwiper={(s) => setSwiper(s)}
  //             className="explore-swiper-wrapper"
  //           >
  //             {sortedDailyFirstExploredDishes.map((dish, index) => {
  //               const labelsArrayValue = getLabelsArrayValue(
  //                 dish,
  //                 exploreVideos[index]
  //               );
  //               const descriptions = dish.stories.map(
  //                 (item) => item?.description
  //               );
  //               const headers = dish?.name;
  //               const price = dish?.price;
  //               const chefId = dish?.chefId;
  //               const description = dish?.description;
  //               const chefImgs = dish?.chefImg;
  //               const chefNames = dish?.chefName;
  //               const labels = dish.stories.map((d) => ({
  //                 key: d.header,
  //                 desc: d.caption,
  //                 img: d.img,
  //                 videoLength: d?.videoLength,
  //                 demoLabel: d?.demoLabel,
  //                 demoDesc: d?.demoDesc,
  //                 storyType: d?.storyType,
  //                 storyHeader: d?.storyHeader,
  //                 dishNameHeader: d?.dishNameHeader,
  //                 exploreCenterHeader: d?.exploreCenterHeader,
  //                 exploreCenterLabel: d?.exploreCenterLabel,
  //                 exploreCenterHeader1: d?.exploreCenterHeader1,
  //                 highlightedText: d?.highlightedText,
  //               }));
  //               const labelsArray = getLabelsArray(
  //                 dish,
  //                 exploreVideos[index],
  //                 labels
  //               );
  //               const storiesArrayData = labelsArray.map((label, i) => ({
  //                 content: ({ action, isPaused }) => {
  //                   // if (!isActive) {
  //                   //   setTimeout(() => {
  //                   //     action('pause');
  //                   //   }, 0);
  //                   // }
  //                   // else if (!isPaused) {
  //                   //   setTimeout(() => {
  //                   //     action('play');
  //                   //   }, 0);
  //                   // }
  //                   if (showInstallModal || showChoiceModal) {
  //                     action("pause");
  //                     // mixpanel.track(`explore story paused ${dish._id}`);
  //                     // clevertap.event.push(`explore story paused ${dish._id}`);
  //                   }
  //                   return (
  //                     <ExploreStory
  //                       key={dish._id}
  //                       dishKey={i}
  //                       img={label.img || dish.stories[0].img}
  //                       action={action}
  //                       labels={labels}
  //                       labelDesc={label}
  //                       dishInfo={dish}
  //                       isPaused={isPaused}
  //                       // isActive={isActive}
  //                       // isNext={isNext}
  //                       // isPrev={isPrev}
  //                       swiper={swiper}
  //                       headers={headers}
  //                       exploreIndex={index}
  //                       name={dish?.categoryHeader}
  //                       categoryImg={
  //                         dish.categoryImg
  //                           ? S3_MENU_THUMBNAIL_FOLDER + dish.categoryImg
  //                           : ""
  //                       }
  //                       price={price}
  //                       dishSpecialType={dish?.dishSpecialType}
  //                       chefId={chefId}
  //                       description={descriptions[i] || description}
  //                       storyImages={dish.storyImages}
  //                       chefImg={chefImgs}
  //                       chefName={chefNames}
  //                       categoryId={dish.categoryId}
  //                       setShowWaitListScreen={setShowWaitListScreen}
  //                     />
  //                   );
  //                 },
  //                 preloadResource: true,
  //                 duration: label?.videoLength + 1000 || 5000,
  //                 enableSwipeUp: label?.highlightedText === "JOIN_WAITLIST"
  //               }));
  //               return (
  //                 <SwiperSlide key={index}>
  //                   <ReactInstaStories
  //                     key={index}
  //                     isPaused={true}
  //                     loop
  //                     stories={storiesArrayData}
  //                     defaultInterval={5000}
  //                     width="100%"
  //                     preloadCount={2}
  //                     height={screenHeight}
  //                     progressContainerStyles={{ top: "2px" }}
  //                     onSwipeUp={handleSwipeUp}
  //                     onStoryStart={(s) => {
  //                       if (index === swiperIndexRef.current) {
  //                         startTimestampRef.current = performance.now();
  //                         storySlideNumber = s;
  //                       }
  //                     }}
  //                     onStoryEnd={(s) => {
  //                       mixpanel.track(`explore story end`);
  //                       // clevertap.event.push(`explore story end`);
  //                       isAutoStoryEndRef.current = true;
  //                       exploreDishesApi(dish);
  //                       if (index === swiperIndexRef.current) {
  //                         storySlideNumber = s;
  //                       }
  //                       if (startTimestampRef.current !== null) {
  //                         const endTimestamp = performance.now();
  //                         const timeDifference =
  //                           endTimestamp - startTimestampRef.current;
  //                         if (timeDifference > 5300) {
  //                           const pausedDishesIds = user.pausedDishesIds || [];
  //                           const allDishesPausedIds = [
  //                             ...new Set([...pausedDishesIds, dish._id]),
  //                           ];
  //                           const payload = {
  //                             pausedDishesIds: allDishesPausedIds,
  //                           };
  //                           // dispatch(updatePausedDishesInfo(user.userid, payload));
  //                         }
  //                         startTimestampRef.current = performance.now();
  //                       }
  //                       // if (s === dish.stories.length + 1 - 1) {
  //                       if (s === labelsArrayValue.length - 1) {
  //                         if (
  //                           showInstallModalAnswered ||
  //                           isAppInstalled ||
  //                           isIosAppInstalled
  //                         ) {
  //                           const canSwipe = swipeToNextSlide();
  //                           if (canSwipe) {
  //                             storySlideNumber = 0;
  //                             my_swiper.slideNext();
  //                           } else {
  //                             dispatch(chefActions.onStoryBackClick());
  //                           }
  //                         } else {
  //                           if (!isAppInstalled && !isIosAppInstalled) {
  //                             // setShowInstallModal(true);
  //                           } else if (!foodChoiceState) {
  //                             // setShowChoiceModal(true);
  //                           } else {
  //                             const canSwipe = swipeToNextSlide();
  //                             if (canSwipe) {
  //                               storySlideNumber = 0;
  //                               my_swiper.slideNext();
  //                             } else {
  //                               dispatch(chefActions.onStoryBackClick());
  //                             }
  //                           }
  //                         }
  //                       }
  //                     }}
  //                   />
  //                 </SwiperSlide>
  //               );
  //             })}
  //           </Swiper>
  //         ) : (
  //           <RecommendationModal
  //             isModalOpen={isModalOpen}
  //             handleCancel={handleCancel}
  //           />
  //         )}{" "}
  //       </>
  //     )}
  //     {showWaitListScreen && <JoinWaitlistComponent setShowWaitListScreen={setShowWaitListScreen} />}
  //     <InstallModal
  //       isOpen={showInstallModal}
  //       setOpen={setShowInstallModal}
  //       setShowChoiceModal={setShowChoiceModal}
  //       foodChoiceState={foodChoiceState}
  //       setShowInstallModalAnswered={handleShowModal}
  //     />
  //     <VegChoiceModal
  //       isOpen={showChoiceModal}
  //       setOpen={setShowChoiceModal}
  //       setFoodChoiceState={handleFoodChoiceState}
  //     />
  //     <LocationChoiceModal
  //       isOpen={showLocationModal}
  //       setOpen={setShowLocationModal}
  //       loading={loading}
  //       isLocationValid={isLocationValid}
  //       manualLocationClick={manualLocationClick}
  //       onGeoLocationClickHandler={onGeoLocationClickHandler}
  //     />
  //     <BottomBar isExplore />
  //   </div>
  // );
};

export default Explore;
